import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Courses from "./components/Courses";
import UpcomingAssignments from "./components/UpcomingAssignments";
import MagicAssignment from "./components/MagicAssignment";
import ReportCard from "./components/ReportCard";
import DeepLinkTool from "./components/DeepLinkTool"; // Import DeepLinkTool
import ShowUserInfo from "./components/ShowUserInfo"; // Import ShowUserInfo
import LTIAssignment from "./components/LTIAssignment"; // Import LTIAssignment
import CourseTutorTool from "./components/CourseTutorTool"; // Import CourseTutorTool
import UEFBase from "./components/UEFBase"; // Import UEFBase
import UEFBaseNav from "./components/UEFBaseNav";
import UEFCourseDetails from "./components/UEFCourseDetails";
import MessageCenterTool from "./components/MessageCenterTool";
import NotificationCenterTool from "./components/NotificationCenterTool";
import EventPublicationTool from "./components/EventPublicationTool";
import CourseDetails from "./components/CourseDetails"; // Import the CourseDetails component
import SetCategory from "./components/SetCategory";
import UploadRubric from "./components/UploadRubric";
import SportsAndStudents from "./components/SportsAndStudents";
import DownloadVideos from "./components/DownloadVideos";
import QuickEnroll from "./components/QuickEnroll";

function App() {
    return (
        <div className="bb-container">
            <Router>
                <Routes>
                    <Route path="/" element={<ConditionalRoute />} />
                </Routes>
            </Router>
        </div>
    );
}

function ConditionalRoute() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Retrieve query parameters
    const route = queryParams.get("route");
    const encodedState = queryParams.get("state");

    // Decode and parse the `state` parameter if it exists
    let state = {};
    if (encodedState) {
        try {
            state = JSON.parse(decodeURIComponent(atob(encodedState))); // Base64 decode and parse
        } catch (error) {
            console.error("Failed to decode state:", error);
        }
    }

    if (route === "MyCourses") {
        return <Courses platformUrl={state.platformUrl}/>;
    }

    if (route === "Assignments") {
        return <UpcomingAssignments platformUrl={state.platformUrl}/>;
    }

    if (route === "MagicAssignment") {
        return <MagicAssignment />;
    }

    if (route === "ReportCard") {
        return <ReportCard platformUrl={state.platformUrl}/>;
    }

    if (route === "DeepLinkTool") {
        return <DeepLinkTool backEndUrl={state.backendUrl} encodedState={encodedState} />;
    }

    if (route === "ShowUserInfo") {
        return <ShowUserInfo platformUrl={state.platformUrl}/>;
    }

    if (route === "LTIAssignment") {
        return <LTIAssignment />;
    }

    if (route === "CourseTutorTool") {
        return <CourseTutorTool platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "UEFBase") {
        return <UEFBase platformUrl={state.platformUrl} />;
    }

    if (route === "UEFBaseNav") {
        return <UEFBaseNav platformUrl={state.platformUrl} />;
    }

    if (route === "UEFCourseDetails") {
        return <UEFCourseDetails platformUrl={state.platformUrl} />;
    }

    if (route === "MessageCenterTool") {
        return <MessageCenterTool backEndUrl={state.backendUrl} platformUrl={state.platformUrl} />;
    }

    if (route === "NotificationCenterTool") {
        return <NotificationCenterTool backEndUrl={state.backendUrl} platformUrl={state.platformUrl} />;
    }

    if (route === "EventPublicationTool") {
        return <EventPublicationTool backEndUrl={state.backendUrl} platformUrl={state.platformUrl} />;
    }

    if (route === "CourseDetails") {
        return <CourseDetails platformUrl={state.platformUrl} />;
    }

    if (route === "SetCategory") {
        return <SetCategory platformUrl={state.platformUrl} />;
    }

    if (route === "UploadRubric") {
        return <UploadRubric platformUrl={state.platformUrl} />;
    }

    if (route === "SportsAndStudents") {
        return <SportsAndStudents backEndUrl={state.backendUrl}/>;
    }

    if (route === "DownloadVideos") {
        return <DownloadVideos backEndUrl={state.backendUrl}/>;
    }

    if (route === "QuickEnroll") {
        return <QuickEnroll backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    return <RouteNotFound />;
}

function RouteNotFound() {
    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h1>Route Not Found</h1>
            <p>The specified route does not exist. Please check the query parameter.</p>
        </div>
    );
}

export default App;
